(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trustpilot-widget"] && !Shopify.designMode) return;
  try {
    
class TrustpilotWidget {
  constructor(container) {
    this.container = container;
    this.track = this.container.querySelector('.tp-track');
    this.dotsContainer = this.container.querySelector('.tp-dots');
    this.nextButton = this.container.querySelector('.tp-nav-next');
    this.prevButton = this.container.querySelector('.tp-nav-prev');
    this.cards = this.container.querySelectorAll('.tp-card');
    
    if (!this.track || this.cards.length <= 3) return;

    this.position = 0;
    this.cardsPerPage = 3;
    this.totalPages = Math.ceil(this.cards.length / this.cardsPerPage);
    
    this.init();
  }

  init() {
    this.createDots();
    this.dots = this.container.querySelectorAll('.tp-dot');
    this.updateCarousel();

    this.nextButton.addEventListener('click', () => this.slide(1));
    this.prevButton.addEventListener('click', () => this.slide(-1));
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });

    setInterval(() => {
      if (window.innerWidth > 768) {
        this.slide(1);
      }
    }, 5000);

    window.addEventListener('resize', () => this.handleResize());
  }

  createDots() {
    if (this.totalPages <= 1) return;
    this.dotsContainer.innerHTML = '';
    for (let i = 0; i < this.totalPages; i++) {
      const button = document.createElement('button');
      button.classList.add('tp-dot');
      button.setAttribute('aria-label', `Go to slide ${i + 1}`);
      this.dotsContainer.appendChild(button);
    }
  }

  updateCarousel() {
    if (window.innerWidth > 768) {
      this.track.style.transform = `translateX(-${this.position * 100}%)`;
      this.dots.forEach((d, i) => d.classList.toggle('active', i === this.position));
    }
  }

  slide(direction) {
    this.position += direction;
    if (this.position >= this.totalPages) {
      this.position = 0;
    }
    if (this.position < 0) {
      this.position = this.totalPages - 1;
    }
    this.updateCarousel();
  }

  goTo(page) {
    this.position = page;
    this.updateCarousel();
  }
  
  handleResize() {
    if (window.innerWidth <= 768) {
      this.track.style.transform = 'none';
    } else {
      this.updateCarousel();
    }
  }
}

const widgetContainer = document.getElementById('TrustpilotWidget-{{ section.id }}');
if (widgetContainer) {
  new TrustpilotWidget(widgetContainer);
}

  } catch(e) { console.error(e); }
})();
})();
